<template>
  <div :id="parameter.name" class="">
    <p class="mb-2 text-sm font-semibold">
      {{ parameterNames[parameter.name] }}
    </p>

    <div v-if="parameter.values.length === 1" class="flex justify-between">
      <div
        class="flex-1 px-3 py-2"
        :class="parameter.selected ? 'bg-green-100' : 'bg-gray-200'"
      >
        {{ parameter.values[0] }}
      </div>
      <base-button
        v-if="parameter.lastSelection"
        @click="
          $emit('reset', { name: parameter.name, value: parameter.values[0] })
        "
        theme="orange"
      >
        <icon-close title="Reset selection" />
      </base-button>
    </div>

    <select
      v-else
      @change="
        ($event) =>
          $emit('input', { name: parameter.name, value: $event.target.value })
      "
      class="block w-full px-3 py-2"
    >
      <option value="" disabled selected></option>
      <option v-for="option in parameter.values" :key="option" :value="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  inheritAttrs: false,
  props: {
    parameter: Object,
  },
  computed: {
    ...mapState({
      parameterNames: (state) => state.company.parameterNames,
    }),
  },
};
</script>
